import { put } from '../Services/http';
import { catchError } from './Error.action';

export const setNotifyEmailWhenInStock = (systemId) => (dispatch, getState) => {
  return put('/api/productStock/setNotifyEmailWhenInStock', systemId)
    .then((response) => response)
    .then((result) => {})
    .catch((ex) => dispatch(catchError(ex, (error) => {})));
};
